/* eslint-disable react/no-danger */
import React, { Fragment } from 'react'

import {
  Icon,
  ChevronRight,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  array,
  string,
  number,
  bool,
  shape,
} from 'prop-types'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import WithListingPageContext from './WithListingPageContext'

const DEFAULT_FREE_TO_PREMIUM_TEXT = {
  prefix: '',
  main: '',
  postfix: '',
}

function TopCategoryBanner({
  title,
  description,
  breadcrumbs,
  currentProductType,
  relatedTagsUrlWithoutTag,
  currentPage,
  seoTags = EMPTY_ARRAY,
  isFree = false,
  pageCategory = '',
  freeToPremiumText = DEFAULT_FREE_TO_PREMIUM_TEXT,
  pathName = '',
  breadcrumbsType = '',
  rootPath = '',
  validBrowserType = EMPTY_ARRAY,
}) {
  const {
    prefix,
    main,
    postfix,
  } = freeToPremiumText
  const hasFreeToPremiumText = isFree && prefix && main && postfix
  const hasFreeToPremiumLink = pathName && pageCategory

  let browseByType = validBrowserType
    // eslint-disable-next-line react/prop-types
    .filter((el) => el.categoryUrl !== pathName)
    .filter((el) => rootPath === '3d-models' || !el.categoryUrl.includes(pathName))

  if (rootPath !== '3d-models') {
    browseByType = browseByType.filter((el) => !el.categoryUrl.includes(rootPath))
  }

  return (
    <div
      id="top-category-banner"
      className="top-category-banner"
    >
      <div className="top-category-banner__container cgt-card cgt-card--inner-space is-rounded cgt-card--border">
        <h1 className="top-category-banner__title cgt-legacy-heading-h6">
          {`${currentPage > 1 ? `Page ${currentPage} of ${title} ` : title}`}
        </h1>
        {hasFreeToPremiumText && hasFreeToPremiumLink && (
          <p>{prefix}{' '}
            <a href={`${pathName}/${pageCategory}`}>
              {main}
            </a>
            {' '}{postfix}
          </p>
        )}
        <div
          className="top-category-banner__description"
          dangerouslySetInnerHTML={{ __html: description }}
        />
        <div className="top-category-banner__links">
          <span
            className="top-category-banner__breadcrumbs"
            dangerouslySetInnerHTML={{ __html: breadcrumbs }}
          />
          {seoTags && seoTags.length > 0 && (
            <Fragment>
              <Icon notSpaced svgComponent={ChevronRight} color="dark" />
              <ul className="related-tags">
                {seoTags.map((tag, index) => (
                  <li className="list__item" key={index}>
                    <a
                      className="js-suggested-tag"
                      href={tag.categoryUrl || `${relatedTagsUrlWithoutTag}/${tag.tag}`}
                      data-search-page={currentProductType}
                      data-top-links="Tag page top links"
                      data-tag={tag.tag}
                    >
                      {tag.key}
                    </a>
                  </li>
                ))}
              </ul>
            </Fragment>
          )}
        </div>

        {pageCategory && browseByType && browseByType.length > 0 &&
          <div className="top-category-banner__links">
            <span
              className="top-category-banner__breadcrumbs"
              dangerouslySetInnerHTML={{ __html: breadcrumbsType }}
            />
            {browseByType && browseByType.length > 0 && (
              <Fragment>
                <Icon notSpaced svgComponent={ChevronRight} color="dark" />
                <ul className="related-tags">
                  {browseByType.map((tag, index) => (
                    <li className="list__item" key={index}>
                      <a
                        className="js-suggested-tag"
                        href={tag.categoryUrl || `${relatedTagsUrlWithoutTag}/${tag.tag}`}
                        data-search-page={currentProductType}
                        data-top-links="Tag page top links"
                        data-tag={tag.tag}
                      >
                        {tag.tag}
                      </a>
                    </li>
                  ))}
                </ul>
              </Fragment>
            )}
          </div>}
      </div>
    </div>
  )
}

TopCategoryBanner.propTypes = {
  title: string.isRequired,
  description: string.isRequired,
  breadcrumbs: string.isRequired,
  currentProductType: string.isRequired,
  relatedTagsUrlWithoutTag: string.isRequired,
  seoTags: array,
  currentPage: number.isRequired,
  isFree: bool,
  pageCategory: string,
  pathName: string,
  freeToPremiumText: shape({
    prefix: string,
    main: string,
    postfix: string,
  }),
  breadcrumbsType: string,
  rootPath: string,
  validBrowserType: array,
}

const mapStateToProps = ({
  currentMeta: {
    currentPage,
  },
  pageCategory,
}) => ({
  currentPage: Number(currentPage),
  pageCategory,
})

export default WithListingPageContext(mapStateToProps)(TopCategoryBanner)
